module.exports = __webpack_public_path__ + "static/media/main idea.ba69a31c.mp3";